import type * as Api from 'Api'

export const venueErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
